module.exports = __webpack_public_path__ + "static/1-7462b51c2a504424893c54e367982747.gif";